import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { RememberMeReqType } from "../../../../Orchestrator/Types/Types/Passenger/PassengerType";

export class RememberMeChangeAction extends BaseAction<void, RememberMeReqType> {

    override async run(): Promise<void | null> {
        try {
            const { checked, passengerId, passengers } = this.params!;
            updateRecoilState("passengerStateAtom",
                passengers.map((passenger) =>
                    passenger.id === passengerId
                        ? { ...passenger, remember: checked }
                        : passenger
                )
            )
        } catch (error) {
            console.error("Error in RememberMeChangeAction:", error);
        }
    }
}

// Create a singleton instance
export const rememberMeChangeAction = new RememberMeChangeAction(); 